module.exports = __webpack_public_path__ + "img/free_bidding.9df19110.png";